var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSync(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Plus",
    transform: "translate(-376 -50.353)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(376 50.353)",
    fill: "#ff6dbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "sync",
    d: "M18,3.038V6.244a1.125,1.125,0,0,1-1.125,1.125H13.669a1.125,1.125,0,0,1,0-2.25h.86A6.756,6.756,0,0,0,2.712,6.541a1.125,1.125,0,0,1-2.1-.82A9,9,0,0,1,15.75,3.045V3.038a1.125,1.125,0,0,1,2.25,0Zm-1.254,7.784a1.125,1.125,0,0,0-1.458.638A6.757,6.757,0,0,1,3.552,12.994h.779a1.125,1.125,0,1,0,0-2.25H1.125A1.125,1.125,0,0,0,0,11.869v3.206a1.125,1.125,0,1,0,2.25,0v-.12a9.054,9.054,0,0,0,1.619,1.439,9,9,0,0,0,13.515-4.116,1.125,1.125,0,0,0-.638-1.458Z",
    transform: "translate(383 57.353)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSync);
export default __webpack_public_path__ + "static/media/icon_sync.2a5784ebe49ef1b472237484a056ca2e.svg";
export { ForwardRef as ReactComponent };